import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom'
import { AppLayout } from 'layout/app-layout'
import { PrivateRoutes } from 'components/hoc/private-routes'
import { pageConfig } from 'app/page-config'

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path={pageConfig.home} element={<AppLayout />}>
      <Route path={pageConfig.home} element={<PrivateRoutes />}>
        <Route
          path={pageConfig.cart}
          lazy={async () => {
            let { CartPage } = await import('app/pages/cart-page')
            return { Component: CartPage }
          }}
        />
        <Route
          path={pageConfig.profile}
          lazy={async () => {
            let { ProfilePage } = await import('app/pages/profile-page')
            return { Component: ProfilePage }
          }}
        />
      </Route>
      <Route
        index
        lazy={async () => {
          let { HomePage } = await import('app/pages/home-page')
          return { Component: HomePage }
        }}
      />
      <Route
        path={pageConfig.productCategory}
        lazy={async () => {
          let { ProductsPage } = await import('app/pages/products-page')
          return { Component: ProductsPage }
        }}
      />
      <Route
        path={pageConfig.productDetails}
        lazy={async () => {
          let { ProductPage } = await import('app/pages/product-page')
          return { Component: ProductPage }
        }}
      />
      <Route
        path={pageConfig.auth}
        lazy={async () => {
          let { AuthPage } = await import('app/pages/auth-page')
          return { Component: AuthPage }
        }}
      />
      <Route
        path="*"
        lazy={async () => {
          let { NotFoundPage } = await import('app/pages/not-found-page')
          return { Component: NotFoundPage }
        }}
      />
    </Route>,
  ),
)

export const App = () => {
  return <RouterProvider router={router} />
}
